import Vue from 'vue';
import orderEventTransformer from './../../transformers/orderEvent';
import store from './../../store';

const success = ({ data }, resolve) => {
  const events = orderEventTransformer.fetchCollection(data.data);

  store.dispatch('fetchOrderEvents', events);
  resolve(events);
};

const failed = () => {};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/orders/events/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/events.js